import { useEffect, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

const READER_ID = "qr-reader";

export function extractRoomId(text) {
    if (!text) return null;
    const urlMatch = text.match(/\/(?:r|s|a)\/([0-9a-fA-F-]{36})/);
    if (urlMatch) return urlMatch[1];
    const plain = text.trim().match(/^[0-9a-fA-F-]{36}$/);
    return plain ? plain[0] : null;
}

export function QrScanner({ onScan }) {
    const [error, setError] = useState("");

    useEffect(() => {
        const scanner = new Html5Qrcode(READER_ID);
        let stopped = false;
        scanner
            .start(
                { facingMode: "environment" },
                { fps: 10, qrbox: { width: 240, height: 240 } },
                (decoded) => {
                    const roomId = extractRoomId(decoded);
                    if (roomId && !stopped) {
                        stopped = true;
                        scanner.stop().catch(() => {});
                        onScan(roomId);
                    }
                },
                () => {}
            )
            .catch(() => setError("Kamera tidak dapat diakses. Izinkan kamera, atau gunakan input manual di bawah."));
        return () => {
            if (!stopped) {
                stopped = true;
                try {
                    scanner.stop().then(() => scanner.clear()).catch(() => {});
                } catch {
                    // scanner belum pernah start
                }
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div id={READER_ID} className="border border-border bg-white overflow-hidden" data-testid="qr-scanner" />
            {error && (
                <p className="text-xs text-destructive mt-2" data-testid="qr-scanner-error">
                    {error}
                </p>
            )}
        </div>
    );
}
